module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "rgba(0,0,0,0.4)"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "10%",
      "padding": "30px",
      "color": "white"
    }
  }, [_c('center', [(!_vm.text) ? _c('span', [_vm._v("You do not have access to the page you requested")]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', [_vm._v("You do not have access to the page: " + _vm._s(_vm.text))]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f8aeebb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page_substitutes/hydroware-access-to-page-denied.vue
// module id = 781
// module chunks = 1